import * as Sentry from "@sentry/browser";

interface SentryConfig {
  dsn: string;
  env: string;
  release: string;
}

export function initSentry(): void {
  const el = document.getElementById("sentry-config");
  if (!el?.textContent) return;

  try {
    const config: SentryConfig = JSON.parse(el.textContent);
    if (!config.dsn) return;

    Sentry.init({
      dsn: config.dsn,
      environment: config.env || "development",
      release: config.release || "dev",
      integrations: [Sentry.browserTracingIntegration()],
      tracesSampleRate: 0.1,
    });
  } catch {
    // Sentry config not available — skip silently
  }
}
